<template>
  <jet-action-section>
    <template #title>Delete account</template>

    <template #description>
      <div class="my-3">
        Permanently delete your account and all data. This action is irreversible. Download any data
        you want to keep before proceeding.
      </div>
    </template>

    <template #content>
      <div class="mt-5 mb-2">
        <jet-danger-button data-cy="user-delete-account" @click="confirmUserDeletion">
          Delete account
        </jet-danger-button>
      </div>

      <!-- Delete Account Confirmation Modal -->
      <jet-dialog-modal :show="confirmingUserDeletion" @close="closeModal">
        <template #title><span class="text-vice-teal-900">Delete account</span></template>

        <template #content>
          <span class="text-vice-teal-900">
            Are you sure you want to delete your account? Once your account is deleted, all of its
            resources and data will be permanently deleted. Please enter your password to confirm
            you would like to permanently delete your account.
          </span>

          <div class="mt-4">
            <jet-input
              data-cy="user-delete-account-password"
              type="password"
              class="mt-1 block w-3/4"
              placeholder="Password"
              ref="password"
              v-model="form.password"
              @keyup.enter="deleteUser"
            />

            <jet-input-error :message="form.errors.password" class="mt-2" />
          </div>
        </template>

        <template #footer>
          <jet-secondary-button data-cy="user-delete-account-password-cancel" @click="closeModal">
            Cancel
          </jet-secondary-button>

          <jet-danger-button
            data-cy="user-delete-account-password-confirm"
            class="ml-2"
            @click="deleteUser"
            :class="{ 'opacity-25': form.processing }"
            :disabled="form.processing"
          >
            Delete account
          </jet-danger-button>
        </template>
      </jet-dialog-modal>
    </template>
  </jet-action-section>
</template>

<script>
import JetActionSection from '@/Jetstream/ActionSection.vue';
import JetDialogModal from '@/Jetstream/DialogModal.vue';
import JetDangerButton from '@/Jetstream/DangerButton.vue';
import JetInput from '@/Jetstream/Input.vue';
import JetInputError from '@/Jetstream/InputError.vue';
import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue';

export default {
  components: {
    JetActionSection,
    JetDangerButton,
    JetDialogModal,
    JetInput,
    JetInputError,
    JetSecondaryButton,
  },

  data() {
    return {
      confirmingUserDeletion: false,

      form: this.$inertia.form({
        password: '',
      }),
    };
  },

  methods: {
    confirmUserDeletion() {
      this.confirmingUserDeletion = true;

      setTimeout(() => this.$refs.password.focus(), 250);
    },

    deleteUser() {
      if (!this.form.errors.password) {
        this.form.delete(route('current-user.destroy'), {
          preserveScroll: true,
          onSuccess: () => this.closeModal(),
          onError: () => this.$refs.password.focus(),
          onFinish: () => this.form.reset(),
        });
      }
    },

    closeModal() {
      this.confirmingUserDeletion = false;

      this.form.reset();
      this.form.errors.password = '';
    },
  },
};
</script>
